import React from 'react';
import { NavLink } from "react-router-dom";
import LevelTwo from '../components/Home/LevelTwo';
import LevelThree from '../components/Home/LevelThree';
import { StyleOne } from '../components/HomeWidgets';
import advisory from '../assets/images/advisory.svg'
import cashM from '../assets/images/cashM.svg'
import RiskM from '../assets/images/riskM.svg'
import financing from '../assets/images/financing.svg'
import wealthM from '../assets/images/wealthM.svg'
import {CardTwoFill, CardTwoOutine} from '../components/contentCards/cardTwo';
import Carousel from '../components/Carousel';

import imageOne from '../assets/images/jeremy-bishop-102621-unsplash.jpg';
import imageTwo from '../assets/images/jeremy-bishop-1634576-unsplash.jpg';
import imageThree from '../assets/images/LP3.jpg';
import imageFour from '../assets/images/LP2.jpg';
import imageFive from '../assets/images/IMG_0439.jpg';




export default class Home extends React.Component {
    render() {
        return (
            <div className="home">
                
                    <div id="carouselExampleControls" className="carousel slide" data-ride="carousel">

                            <ol class="carousel-indicators">
                                <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
                                <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                                <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                                <li data-target="#carouselExampleIndicators" data-slide-to="3"></li>
                                <li data-target="#carouselExampleIndicators" data-slide-to="4"></li>
                            </ol>

                        <div className="carousel-inner">

                            <div className="carousel-item active">

                                <div className="hero"  style={{backgroundImage: `url(${imageOne})`}}>
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-6"></div>
                                            <div className="col-10 col-md-6 text-left">
                                                {/* <span className="badge badge-about">ABOUT US</span> */}
                                                <h1 style={{marginTop:120}}>Providing in-depth industry expertise</h1>
                                                {/* <hr />
                                                <p></p>
                                                <NavLink to="/about" className="white-bordered-button">Learn more</NavLink> */}
                                                <br /><br />
                                                {/* <br /><br /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div className="carousel-item">

                                <div className="hero" style={{backgroundImage: `url(${imageTwo})`}}>
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-6"></div>
                                            <div className="col-10 col-md-6 text-left">
                                                {/* <span className="badge badge-about">ABOUT US</span> */}
                                                <h1 style={{marginTop:120}}>Reaching new investment heights</h1>
                                                {/* <hr />
                                                <p></p>
                                                <NavLink to="/about" className="white-bordered-button">Learn more</NavLink> */}
                                                <br /><br />
                                                {/* <br /><br /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div className="carousel-item">

                                <div className="hero" style={{backgroundImage: `url(${imageThree})`}}>
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-6"></div>
                                            <div className="col-10 col-md-6 text-left">
                                                {/* <span className="badge badge-about">ABOUT US</span> */}
                                                <h1 style={{marginTop:120, color:'black'}}>Building and sustaining wealth</h1>
                                                {/* <hr />
                                                <p>
                                                Backed by a rich heritage and driven by our ‘Together, we achieve more’ approach, the FSDH brand has become synonymous with trust, innovation, and reliability. 
                                                </p>
                                                <NavLink to="/about" className="white-bordered-button">Learn more</NavLink> */}
                                                <br /><br />
                                                {/* <br /><br /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div className="carousel-item">

                                <div className="hero" style={{backgroundImage: `url(${imageFour})`}}>
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-6"></div>
                                            <div className="col-10 col-md-6 text-left">
                                                {/* <span className="badge badge-about">ABOUT US</span> */}
                                                <h1 style={{marginTop:120}}>Connecting financial goals with reality</h1>
                                                {/* <hr />
                                                <p>
                                                Backed by a rich heritage and driven by our ‘Together, we achieve more’ approach, the FSDH brand has become synonymous with trust, innovation, and reliability. 
                                                </p>
                                                <NavLink to="/about" className="white-bordered-button">Learn more</NavLink> */}
                                                <br /><br />
                                                {/* <br /><br /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>


                            <div className="carousel-item">

                                <div className="hero" style={{backgroundImage: `url(${imageFive})`}}>
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-6"></div>
                                            <div className="col-10 col-md-6 text-left">
                                                {/* <span className="badge badge-about">ABOUT US</span> */}
                                                <h1 style={{marginTop:120}}>Financial partners you can trust</h1>
                                                {/* <hr />
                                                <p>
                                                Backed by a rich heritage and driven by our ‘Together, we achieve more’ approach, the FSDH brand has become synonymous with trust, innovation, and reliability. 
                                                </p>
                                                <NavLink to="/about" className="white-bordered-button">Learn more</NavLink> */}
                                                <br /><br />
                                                {/* <br /><br /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        
                        </div>
                        <div className="right carousel-controls">
                              <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="sr-only">Previous</span>
                              </a>
                              <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="sr-only">Next</span>
                              </a>
                            </div>
                    </div>

                <div className="section-alt">
                    <div className="container-fluid">
                        <div className="row justify-content-center">
                            <StyleOne url='/servicelist/cManagement' imag={cashM} serviceDesc='Cash Management' bgcolor='burgundy-bg' buttonText='LEARN MORE'/>
                            <StyleOne url='/servicelist/wManagement' imag={wealthM} serviceDesc='Wealth Management' bgcolor='burgundy-bg' buttonText='LEARN MORE'/>
                            <StyleOne url='/servicelist/rManagement' imag={RiskM} serviceDesc='Risk Management' bgcolor='light-blue-bg' buttonText='LEARN MORE'/>
                            <StyleOne url='/productlist/cBanking' imag={financing} serviceDesc='Financing' bgcolor='burgundy-bg' buttonText='LEARN MORE'/>
                            <StyleOne url='/servicelist/advisory' imag={advisory} serviceDesc='Advisory' bgcolor='dark-blue-bg' buttonText='LEARN MORE'/>
                        </div>
                    </div>
                </div>

                <div className="">
                    <div className="container-fluid">
                        {/* <LevelTwo /> */}
                        {/* <LevelThree gridNumber={3} /> */}
                    </div>
                    {/* <div className="container-fluid">
                        <div className="row">
                        <CardTwoOutine nLink='/' tagName="services" ServiceName="Treasury" ButtonText="Learn more" BgColor="dark-blue-bg"
                        ServiceDesc="We are a leading organization in the sale of Local and Foreign Currencies related products to non-bank clients for the purpose of investment and risk management." />
                        <CardTwoOutine nLink='/' tagName="services" ServiceName="Financing" ButtonText="Learn more" BgColor="dark-blue-bg"
                        ServiceDesc="We are a leading organization in the sale of Local and Foreign Currencies related products to non-bank clients for the purpose of investment and risk management." />
                        <CardTwoOutine nLink='/' tagName="services" ServiceName="Wealth Management" ButtonText="Learn more" BgColor="dark-blue-bg"
                        ServiceDesc="We are a leading organization in the sale of Local and Foreign Currencies related products to non-bank clients for the purpose of investment and risk management." />
                        </div>
                    </div> */}
                </div>
            </div>
        );
    }
}